import { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import StatusTag from './StatusTag';

type TimelineVariant = 'green' | 'blue' | 'gold' | 'orange' | 'red' | 'teal' | 'purple' | 'gray';

interface TimelineItemProps {
  title: string;
  subtitle: string;
  variant: TimelineVariant;
  tag?: { label: string; variant: TimelineVariant };
}

const TimelineItem: FC<TimelineItemProps> = ({ title, subtitle, variant, tag }) => (
  <Stack direction="row" alignItems="flex-start" gap={4}>
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        // Punktfarbe aus `theme.palette.status` (Design-Paket 3) — eine Quelle mit StatusTag.
        bgcolor: `status.${variant}.punkt`,
        flexShrink: 0,
        mt: 1.5,
      }}
    />
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography variant="wertBetont">
        {title}
      </Typography>
      <Typography variant="klein">
        {subtitle}
      </Typography>
    </Box>
    {tag && <StatusTag label={tag.label} variant={tag.variant} />}
  </Stack>
);

export default TimelineItem;
